import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaLocationDot,
  FaPhone,
  FaRegEnvelope,
  FaXTwitter,
} from "react-icons/fa6";
import logo from "../../../assets/images/logo.png";
import apple from "../../../assets/images/apple.png";
import android from "../../../assets/images/android.png";
import visa from "../../../assets/images/visa.png";
import mastercard from "../../../assets/images/images.png";
import razorpay from "../../../assets/images/Razorpay-Logo.jpg";
import BHIM_Preview from "../../../assets/images/000-bhim.jpg";

const Footer = () => {
  const brandsData = [
    {
      title: "Jewellery",
      items: [
        "Necklace",
        "Earrings",
        "Couple Rings",
        "Pendants",
        "Crystal",
        "Bangles",
        "Bracelets",
        "Nose Pin",
        "Chain",
        "Earrings",
        "Couple Rings",
      ],
    },
    {
      title: "Footwear",
      items: [
        "Sport",
        "Formal",
        "Boots",
        "Casual",
        "Cowboy Shoes",
        "Safety Shoes",
        "Party Wear Shoes",
        "Branded",
        "First Copy",
        "Long Shoes",
      ],
    },
    {
      title: "Fashion",
      items: [
        "T-Shirt",
        "Short & Jeans",
        "Jacket",
        "Dress & Frock",
        "Inner Wear",
        "Hosiery",
      ],
    },
    {
      title: "Cosmetics",
      items: [
        "Shampoo",
        "Body Wash",
        "Face Wash",
        "Makeup Kit",
        "Liner",
        "Lipstick",
        "Perfume",
        "Body Shop",
        "Scrub",
        "Hair Gel",
        "Hair Colors",
        "Hair Dye",
        "Sunscreen",
        "Skin Lotion",
        "Liner",
        "Lipstick",
      ],
    },
  ];

  return (
    <footer className="bg-[#dbf4f1] rounded-3xl my-4 mx-4 md:my-10 md:mx-16">
      <div className="border-b border-gray-200 py-10">
        <div className="container mx-auto px-4">
          <div className="mb-8 text-center">
            <h4 className="text-xl font-semibold text-gray-700">
              BRANDS DIRECTORY
            </h4>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 text-sm text-gray-700">
            {brandsData.map((category, idx) => (
              <div key={idx}>
                <div className="flex flex-wrap items-center mt-2 text-gray-600">
                  <span className="font-bold text-gray-600 flex">
                    {category.title} <span> :</span>
                  </span>
                  {category.items.map((item, i) => (
                    <span
                      key={i}
                      className="flex font-semibold text-gray-500 items-center"
                    >
                      <span className="px-2">{item}</span>
                      {i < category.items.length - 1 && <span>|</span>}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 text-start gap-8">
            <div className="flex flex-col space-y-4">
              <div className="flex items-center space-x-2">
                <a href="/">
                  <img src={logo} alt="Selzor Logo" className="w-32" />
                </a>
              </div>
              <p className="text-sm text-gray-500">
                Selzor is the biggest market of grocery products. Get your daily
                needs from our store.
              </p>
              <div className="flex space-x-2">
                <a href="/">
                  <img
                    src={android}
                    alt="Google Play"
                    className="h-10 rounded-md"
                  />
                </a>
              </div>
            </div>

         

            <div>
              <h4 className="text-lg font-semibold text-gray-600 mb-4">
                Company
              </h4>
              <ul className=" text-gray-500 space-y-2">
                <li>
                  <a
                    href="/about-us"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    About us
                  </a>
                </li>
                <li>
                  <a
                    href="/why-selzor"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    Why Selzor
                  </a>
                </li>
                <li>
                  <a
                    href="/frequently-asked-questions"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    FAQs
                  </a>
                </li>
                <li>
                  <a
                    href="/contact-us"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    Contact us
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-gray-600 mb-4">
                Account & Support
              </h4>
              <ul className=" text-gray-500 space-y-2">
                <li>
                  <a
                    href="https://b2b.selzor.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    Sign In
                  </a>
                </li>
                <li>
                  <a
                    href="/pricing"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    Pricing
                  </a>
                </li>
                <li>
                  <a
                    href="/terms-of-service"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    href="/privacy-policy"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    Return Policy
                  </a>
                </li>
               
              </ul>
            </div>

               <div>
                   
              <ul className="text-gray-500 space-y-2">
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    For Manufacturers
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    For Traders
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    For B2B Suppliers
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    For Sales Reps
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    For
              Distributors
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    For C&F Agents
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                    For Wholesalers 
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:underline hover:text-[#1a9588] transition duration-300 ease-in-out"
                  >
                 For Retailers
                  </a>
                </li>
              </ul>
            </div>


            <div className="lg:col-span-1">
              <h4 className="text-lg font-semibold text-gray-600 mb-4">
                Contact
              </h4>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <FaLocationDot className="h-5 w-5 text-gray-500" />
                  <p className="text-gray-500">
                   SELZOR India
                  </p>
                </div>
                <div className="space-y-3">
                  {/* Number 1 */}
                  <a
                    href="tel:+919370003009"
                    className="flex items-center gap-3 px-4 py-2 rounded-xl border border-gray-200 bg-white shadow-sm text-gray-600 hover:text-[#1a9588] hover:border-[#1a9588] transition duration-300 ease-in-out"
                  >
                    <FaPhone className="text-[#1a9588]" />
                    <span className="font-medium">+91 9370 003 009</span>
                  </a>

                  {/* Number 2 */}
                  <a
                    href="tel:+919323266430"
                    className="flex items-center gap-3 px-4 py-2 rounded-xl border border-gray-200 bg-white shadow-sm text-gray-600 hover:text-[#1a9588] hover:border-[#1a9588] transition duration-300 ease-in-out"
                  >
                    <FaPhone className="text-[#1a9588]" />
                    <span className="font-medium">+91 9323 266 430</span>
                  </a>
                </div>

                <div className="flex items-center space-x-3">
                  <FaRegEnvelope className="h-5 w-5 text-gray-500" />
                  <a
                    href="mailto:sales@selzor.com"
                    className=" text-gray-500 hover:underline hover:text-[#1a9588]"
                  >
                    sales@selzor.com
                  </a>
                </div>
                <div className="flex space-x-4">
                  <a
                    href="/"
                    className="bg-[#b9ece6] text-[#1a9588] p-2 rounded-full hover:bg-[#b4deda] transition duration-300 ease-in-out"
                  >
                    <FaFacebookF className="h-5 w-5" />
                  </a>
                  <a
                    href="/"
                    className="bg-[#b9ece6] text-[#1a9588] p-2 rounded-full hover:bg-[#b4deda] transition duration-300 ease-in-out"
                  >
                    <FaXTwitter className="h-5 w-5" />
                  </a>
                  <a
                    href="/"
                    className="bg-[#b9ece6] text-[#1a9588] p-2 rounded-full hover:bg-[#b4deda] transition duration-300 ease-in-out"
                  >
                    <FaLinkedinIn className="h-5 w-5" />
                  </a>
                  <a
                    href="/"
                    className="bg-[#b9ece6] text-[#1a9588] p-2 rounded-full hover:bg-[#b4deda] transition duration-300 ease-in-out"
                  >
                    <FaInstagram className="h-5 w-5" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-200 py-4">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm">
          <div className="text-center text-gray-700 md:text-left mb-2 md:mb-0">
            <span>
              Copyright © {new Date().getFullYear()}
              <span className="font-bold text-[#1a9588]"> Selzor</span> all
              rights reserved. A Develop by &nbsp;
              <a
                className="text-gray-700 hover:text-gray-800 font-semibold transition duration-300 ease-in-out"
                href="https://hitechenterprise.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Hi Tech Enterprises
              </a>
            </span>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-4   rounded-xl ">
            <div className="p-2 bg-white rounded-lg shadow  transition">
              <img
                src={visa}
                alt="Visa"
                className="h-6 w-auto object-contain"
              />
            </div>
            <div className="p-2 bg-white rounded-lg shadow  transition">
              <img
                src={mastercard}
                alt="Mastercard"
                className="h-6 w-auto object-contain"
              />
            </div>
            <div className="p-2 bg-white rounded-lg shadow  transition">
              <img
                src={razorpay}
                alt="Razorpay"
                className="h-6 w-auto object-contain"
              />
            </div>
            <div className="p-2 bg-white rounded-lg shadow  transition">
              <img
                src={BHIM_Preview}
                alt="BHIM"
                className="h-6 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
